import { FaBook, FaCalendarAlt, FaHome, FaSignInAlt, FaUser } from 'react-icons/fa';

// Configuración de rutas de la aplicación
// Este archivo centraliza todas las rutas para facilitar el mantenimiento

export const routes = {
    // Rutas públicas
    public: {
        login: '/',
        register: '/registro',
        terms: '/terminos-y-condiciones',
        privacy: '/politica-de-privacidad',
        activateAccount: '/activar-cuenta',
    },

    // Rutas privadas (requieren autenticación)
    private: {
        home: '/inicio',
        calendar: '/calendario',
        userProfile: '/perfil-de-usuario',
        learnAboutMyself: '/aprendo-sobre-mi',
        knowYourCycle: '/conoce-tu-ciclo',
        higiene: '/higiene-y-cuidados',
        mythsAndTruths: '/mitos-y-verdades',
        tips: '/autocuidado-y-bienestar',
    },

    // Rutas de redirección
    redirects: {
        notFound: '/', // Redirige rutas no encontradas al login
        afterLogin: '/inicio', // Redirige después del login exitoso
        afterLogout: '/', // Redirige después del logout
    },
} as const;

// Metadata de rutas con iconos y títulos
export interface RouteMetadata {
    title: string;
    pageTitle: string; // Para document.title
    icon: React.ComponentType<any>;
}

export const routeMetadata: Record<string, RouteMetadata> = {
    // Ruta pública
    [routes.public.login]: {
        title: 'Iniciar Sesión',
        pageTitle: 'CICLII - Iniciar Sesión',
        icon: FaSignInAlt,
    },
    [routes.public.register]: {
        title: 'Crea tu cuenta',
        pageTitle: 'CICLII - Crea tu cuenta',
        icon: FaSignInAlt,
    },
    [routes.public.terms]: {
        title: 'Términos y Condiciones',
        pageTitle: 'CICLII - Términos y Condiciones',
        icon: FaSignInAlt,
    },
    [routes.public.privacy]: {
        title: 'Política de Privacidad',
        pageTitle: 'CICLII - Política de Privacidad',
        icon: FaSignInAlt,
    },
    [routes.public.activateAccount]: {
        title: 'Activa tu cuenta',
        pageTitle: 'CICLII - Activa tu cuenta',
        icon: FaSignInAlt,
    },

    // Rutas privadas
    [routes.private.home]: {
        title: 'Inicio',
        pageTitle: 'CICLII - Inicio',
        icon: FaHome,
    },

    [routes.private.calendar]: {
        title: 'Mi Calendario',
        pageTitle: 'CICLII - Mi Calendario',
        icon: FaCalendarAlt,
    },

    [routes.private.learnAboutMyself]: {
        title: 'Aprendo sobre mí',
        pageTitle: 'CICLII - Aprendo sobre mí',
        icon: FaBook,
    },

    // Subrutas de Aprendo sobre mí
    [routes.private.knowYourCycle]: {
        title: 'Conoce tu ciclo',
        pageTitle: 'CICLII - Conoce tu ciclo',
        icon: FaBook,
    },
    [routes.private.higiene]: {
        title: 'Higiene y Cuidados',
        pageTitle: 'CICLII - Higiene y Cuidados',
        icon: FaBook,
    },
    [routes.private.mythsAndTruths]: {
        title: 'Mitos y Verdades',
        pageTitle: 'CICLII - Mitos y Verdades',
        icon: FaBook,
    },
    [routes.private.tips]: {
        title: 'Autocuidado y bienestar',
        pageTitle: 'CICLII - Autocuidado y bienestar',
        icon: FaBook,
    },

    [routes.private.userProfile]: {
        title: 'Mi Perfil',
        pageTitle: 'CICLII - Mi Perfil',
        icon: FaUser,
    },
};

// Exportar también como array para facilitar validaciones
export const publicRoutes = Object.values(routes.public);
export const privateRoutes = Object.values(routes.private);
export const allRoutes = [...publicRoutes, ...privateRoutes];